// src/features/Project/projectslice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getProjects,
  addProject,
  updateProject,
  deleteProject,
  getAssocitateDataByProjectId,
  getProjectHistoryById,
  getProjectById,
} from "./projectApi";

// Thunks
export const fetchProjects = createAsyncThunk(
  "projects/fetchProjects",
  async (paramsOptions) => {
    const response = await getProjects(paramsOptions);
    return { data: response.data, ...response };
  }
);

export const fetchProjectById = createAsyncThunk(
  "projects/fetchProjectById",
  async (_id) => {
    const response = await getProjectById(_id);
    return response.data;
  }
);

export const fetchAssocitateDataProjectById = createAsyncThunk(
  "projects/fetchProjectsAssocicateData",
  async (id, paramsOptions) => {
    const response = await getAssocitateDataByProjectId(id, paramsOptions);
    return response.data;
  }
);
export const fetchProjectHistoryById = createAsyncThunk(
  "projects/fetchProjectsHistoryById",
  async (paramsOptions) => {
    const response = await getProjectHistoryById(paramsOptions);
    return { data: response.data, pagination: response.pagination };
  }
);

export const createProject = createAsyncThunk(
  "projects/createProject",
  async (formData) => {
    const response = await addProject(formData);
    return response;
  }
);


export const updateProjectData = createAsyncThunk(
  "projects/updateProject",
  async (formData) => {
    const response = await updateProject(formData);
    return response;
  }
);

export const deleteProjectById = createAsyncThunk(
  "projects/deleteProject",
  async (id) => {
    const response = await deleteProject(id);
    return response;
  }
);

export const resetProjectById = createAsyncThunk(
  "projects/resetProjectById",
  async () => {
    return {};
  }
);

const projectslice = createSlice({
  name: "projects",
  initialState: {
    projects: [],
    projectById:{},
    projectsAssociateData: [],
    projectHistory: [],
    projectHistoryPagination:{},
    paginationObj: {},
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.projects = data;
        state.paginationObj = pagination;
      })
      .addCase(fetchProjectById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectById = action.payload;
      })
       .addCase(resetProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectById = action.payload;
      })
      .addCase(fetchAssocitateDataProjectById.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAssocitateDataProjectById.fulfilled, (state, action) => {
        state.loading = false;
        state.projectsAssociateData = action.payload;
      })
      .addCase(fetchProjectHistoryById.fulfilled, (state, action) => {
        state.loading = false;
        const { data, pagination } = action.payload || {};
        state.projectHistory = data;
        state.projectHistoryPagination = pagination;
      })
      .addCase(createProject.fulfilled, (state, action) => {
        state.projects.push(action.payload.data);
      })
      .addCase(updateProjectData.fulfilled, (state, action) => {
        const idx = state.projects.findIndex((u) => u.id === action.payload.id);
        if (idx !== -1) {
          state.projects[idx] = action.payload.data;
        }
      })
      .addCase(deleteProjectById.fulfilled, (state, action) => {
        state.projects = state.projects.filter(
          (u) => u.id !== action.payload.id
        );
      });
  },
});

export default projectslice.reducer;
